import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import { IntersectionOptions } from 'react-intersection-observer';

type DetectSticky = {
  isSticky: boolean;
  setIsSticky: Dispatch<SetStateAction<boolean>>;
  getIsSticky: () => boolean;
};
interface DetectStickyProps {
  id: string;
  observerSettings?: IntersectionOptions;
}

const useDetectSticky = ({
  id,
  observerSettings = {
    rootMargin: '-1px 0px 0px 0px',
    threshold: [1, 0],
    trackVisibility: true,
    delay: 100,
  },
}: DetectStickyProps): DetectSticky => {
  const [isSticky, setIsSticky] = useState(false);

  const getIsSticky = useCallback(() => {
    return isSticky;
  }, [isSticky]);

  useEffect(() => {
    const element = document.querySelector(`[${id}]`),
      observer = new IntersectionObserver(([e]) => {
        setIsSticky(e.intersectionRatio < 1 && e.isIntersecting);
      }, observerSettings);
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [id, observerSettings]);

  return { isSticky, setIsSticky, getIsSticky };
};

export { useDetectSticky };
